import style from './style.css';
import Accordion from '../../../../components/accordion';
import limitCheckInfo from '../../../../components/partial/layers/modals/onLimitCheckModal/limitCheckInfo';
import { localLenderDetailsList } from './localLenderDetails';
import { UserActionType, tracker } from '../../../../tracking';

const LendersCard = (props) => {
  const { lenderDetailsList } = props || {};

  return (
    <div className={style.lenderImages}>
      {Array.isArray(lenderDetailsList) &&
        lenderDetailsList.map((lenderDetailsList) => (
          <div className={style.lenderCardWrapper}>
            <Accordion
              isContextCard={true}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'bic_emi_details',
                  '',
                  { lenderName: lenderDetailsList.lenderName },
                );
              }}>
              <Accordion.Item key={'Know More'}>
                <Accordion.Collapsed id={'Know More'} isContextCard={true}>
                  <div className={style.lenderDetailsContainer}>
                    <img
                      src={lenderDetailsList.lenderLogoIcon}
                      className={style.lenderIcon}
                      alt='lender-logo'
                    />
                    <div className={style.lenderTextContainer}>
                      <div className={style.lenderNameText}>
                        {lenderDetailsList.lenderName}
                      </div>
                      {lenderDetailsList.minInterestRate === 0 ? (
                        <div className={style.noCostText}>
                          <span
                            style={{ color: '#0bb246', fontWeight: 'bold' }}>
                            No Cost EMI
                          </span>
                        </div>
                      ) : (
                        <div className={style.interestRateText}>
                          Interest starting at{' '}
                          <span
                            style={{ color: '#0bb246', fontWeight: 'bold' }}>
                            {lenderDetailsList.minInterestRate}% p.a
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </Accordion.Collapsed>
                <Accordion.Expanded isContextCard={true}>
                  <div className={style.emiInfoText}>
                    <ul className={style.listContainer}>
                      {localLenderDetailsList[lenderDetailsList.lenderId] && (
                        <li>
                          {
                            localLenderDetailsList[lenderDetailsList.lenderId]
                              .tenures
                          }
                        </li>
                      )}
                      <li>
                        Min transaction value{' '}
                        <span className='bold-text'>
                          {' '}
                          <span
                            className={`rupeeSymbol ${style.rupeeSymbolFont}`}>
                            &#8377;
                          </span>
                          {lenderDetailsList.minLoanAmount}
                        </span>
                      </li>
                    </ul>
                  </div>
                  {limitCheckInfo[lenderDetailsList.lenderId] && (
                    <div className={style.checkLimitCard}>
                      <span className='bold-text'> To Check Credit Limit:</span>{' '}
                      SMS{' '}
                      <b>{limitCheckInfo[lenderDetailsList.lenderId].text}</b>{' '}
                      to{' '}
                      <b>{limitCheckInfo[lenderDetailsList.lenderId].number}</b>{' '}
                      to check Credit Limit
                    </div>
                  )}
                </Accordion.Expanded>
              </Accordion.Item>
            </Accordion>
          </div>
        ))}
    </div>
  );
};

export default LendersCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEmiDetails/lendersCard/index.js